<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/L1Z5W2/tc-custom/9781788855358.jpg?1726454431877" alt="This image is the cover for the book Cheers, Mr Churchill!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cheers, Mr Churchill!
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1922 Winston Churchill prepared to defend his parliamentary seat of Dundee in the General Election. He had represented the city since 1908, enjoyed a majority of more than 15,000 and, after five previous victories, confidently described it as a ‘life seat’. But one man had other ideas, and Churchill was in for the fight of his life.  This is the story of how god-fearing teetotaller Edwin Scrymgeour fought and won an election against Britain’s most famous politician. It begins with their first electoral contest in 1908 and follows their political sparring over the next 15 years until Scrymgeour’s eventual victory in 1922, when he became the only prohibitionist ever elected to the House of Commons.  As well as vividly bringing to life an extraordinary personal and political rivalry, the book also explores for the first time Churchill’s controversial relationship with Scotland, including his attitude to devolution.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Liddle
      </h2>
      
      <p class="authorDescription body article">Andrew Liddle is a political writer and consultant based in Edinburgh. He was previously Political Correspondent for The Press and Journal and Chief Reporter for The Courier.. His previous books include Ruth Davidson and the Resurgence of the Scottish Tories and Nigel Farage in His Own Words. He lives in Edinburgh.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Birlinn
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?04473808